import React from 'react';
export default function InventoryIcon({
  title
}) {
  /* Icon from MUI v.5 */
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc",
    "aria-labelledby": "title"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title"
  }, title || 'Inventory icon'), /*#__PURE__*/React.createElement("path", {
    d: "M4 7h16V3.98L4 4zm1 13h14V9H5v11zm4-8h6v2H9v-2z",
    color: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 2H4c-1 0-2 .9-2 2v3.01c0 .72.43 1.34 1 1.69V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.7c.57-.35 1-.97 1-1.69V4c0-1.1-1-2-2-2zm-1 18H5V9h14v11zm1-13H4V4l16-.02V7z",
    color: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 12h6v2H9z",
    color: "#f0f0f0"
  }));
}
InventoryIcon.defaultProps = {
  title: undefined
};